import { useRef, useCallback } from 'react';

export const useCreateSubscriptionContext = (initialContext, customSetter = undefined, debug = false, customName = '') => {

  const store = useRef(initialContext);
  const subscribers = useRef(new Set());

  const get = useCallback(() => {
    return store.current;
  }, []);

  const set = useCallback((changes, deleteKeys = [], silent = false) => {
    if (customSetter) {
      store.current = customSetter(store.current, changes);
    } else {
      Object.keys(changes).forEach(changeKey => {
        store.current[changeKey] = changes[changeKey];
      });
      if (deleteKeys.length > 0) {
        deleteKeys.forEach(deleteKey => {
          delete store.current[deleteKey];
        });
      }
    }
    if (debug) {
      console.log("change in context :: ", store.current, changes);
    }
    if (!silent) {
      subscribers.current.forEach(callback => callback(store.current));
    }
  }, []);

  const subscribe = useCallback((callback, customName = '') => {
    if (debug) {
      console.log("Subscribing !! ", customName);
    }
    subscribers.current.add(callback);
    callback(store.current); // Adding this to send the initial store value to new subscriber - needed when component is changing its selector
    return () => {
      if (debug) {
        console.log("Unsubscribing !! ", customName);
      }
      subscribers.current.delete(callback);
    };
  }, []);

  return {
    get,
    set,
    subscribe
  }
}
